import React from "react";
import { connect } from "react-redux";
import T from "prop-types";
import { renderIf, toggleSwitch } from "MODULES/shared/decorators";
import { ConfirmAction, DropDownItem, Icon } from "MODULES/shared/components";
import {
  CREATE_COMMERCIAL_INVOICE,
  UNDO_SCRAP,
  CREATE_DUMMY_RECORD,
  CREATE_VENDOR_RMA,
  RESERVE_INV_FOR_SALE,
  RESERVE_INV_FOR_REPAIR,
  UPDATE_SRP,
  UPDATE_QC_STATUS,
  SCRAP_REPORT_RECEIVED,
  SPLIT_INVENTORY,
  TRANSFER_INVENTORY,
  RETURN_TO_CUSTOMER,
  APPLY_LOT_COST,
  CANCEL_CONSIGNMENT,
  ASSIGN_EXCHANGE,
  PRINT,
  RETURN_TO_CUSTOMER_V2,
  REQUEST_SCRAP_AT_SHOP,
  DOWNLOAD_SCRAP_CERT
} from "MODULES/inventories/constants";
import {
  CancelConsignment,
  CreateCommercialInvoice,
  CreateDummy,
  CreateVendorRma,
  EditReserveForSeller,
  ReserveForRepair,
  ScrapReportReceived,
  SplitInventory,
  Transfer,
  UpdateQCStatus,
  UndoScrap
} from "MODULES/inventories/components/Detail/Header/DropdownActions";
import CreateInventoryShipmentModal from "MODULES/inventories/components/Detail/Header/DropdownActions/CreateInventoryShipment/CreateInventoryShipmentModal";
import ApplyLotCost from "MODULES/inventories/components/Detail/Header/DropdownActions/ApplyLotCost/ApplyLotCost";
import { USER } from "MODULES/users/constants";
import PrintInventory from "MODULES/inventories/components/Detail/Header/DropdownActions/Print/Print";
import AssignToExchange from "MODULES/inventories/components/Detail/Header/DropdownActions/AssignToExchange/AssignToExchange";
import { RequestScrapAtShop } from "MODULES/inventories/components/Detail/Header/DropdownActions/RequestScrapAtShop/RequestScrapAtShop";
import ReturnToCustomer from "MODULES/inventories/components/Detail/Header/DropdownActions/ReturnToCustomer/ReturnToCustomer";
import DownloadScrapReportModal from "MODULES/inventories/components/Detail/Header/DropdownActions/DownloadScrapReport/DownloadScrapReportModal";
import UpdateSrpStatus from "./UpdateSrpStatus/UpdateSrpStatus";

const customModal = {
  [APPLY_LOT_COST]: props => <ApplyLotCost {...props} />,
  [ASSIGN_EXCHANGE]: props => <AssignToExchange {...props} />,
  [CANCEL_CONSIGNMENT]: props => <CancelConsignment {...props} />,
  [DOWNLOAD_SCRAP_CERT]: props => <DownloadScrapReportModal {...props} />,
  [RESERVE_INV_FOR_SALE]: props => <EditReserveForSeller {...props} />,
  [RESERVE_INV_FOR_REPAIR]: props => <ReserveForRepair {...props} />,
  [RETURN_TO_CUSTOMER]: props => <CreateInventoryShipmentModal {...props} />,
  [RETURN_TO_CUSTOMER_V2]: props => <ReturnToCustomer {...props} />,
  [UPDATE_QC_STATUS]: props => <UpdateQCStatus {...props} />,
  [UPDATE_SRP]: props => <UpdateSrpStatus {...props} />,
  [CREATE_DUMMY_RECORD]: props => <CreateDummy {...props} />,
  [REQUEST_SCRAP_AT_SHOP]: props => <RequestScrapAtShop {...props} />,
  [SCRAP_REPORT_RECEIVED]: props => <ScrapReportReceived {...props} />,
  [SPLIT_INVENTORY]: props => <SplitInventory {...props} />,
  [CREATE_VENDOR_RMA]: props => <CreateVendorRma {...props} />,
  [TRANSFER_INVENTORY]: props => <Transfer {...props} />,
  [CREATE_COMMERCIAL_INVOICE]: props => <CreateCommercialInvoice {...props} />,
  [PRINT]: props => <PrintInventory {...props} />,
  [UNDO_SCRAP]: props => <UndoScrap {...props} />
};

const Modal = props => {
  const {
    iconName,
    key,
    text,
    confirmText,
    action,
    btnClass,
    cancelText
  } = props.config;
  if (Object.keys(customModal).includes(key)) {
    return customModal[key](props);
  }

  const { editing, close, dispatch } = props;
  const sendAction = () => dispatch(action(props.inventory.toJS()));

  return (
    <ConfirmAction
      onConfirm={sendAction}
      key={`confirm${key}`}
      close={close}
      btnClass={btnClass}
      cancelText={cancelText}
      open={editing}
      icon={<Icon name={iconName} fixed />}
      btnText={confirmText}
    >
      <strong>Heads up!</strong>
      &nbsp;{text}
    </ConfirmAction>
  );
};

Modal.propTypes = {
  editing: T.bool.isRequired,
  close: T.func.isRequired,
  dispatch: T.func.isRequired,
  inventory: T.shape({
    toJS: T.func.isRequired
  }),
  config: T.shape({
    key: T.string.isRequired,
    dropDownText: T.string.isRequired,
    iconName: T.string.isRequired
  })
};

const Action = props => {
  const { open, config: { iconName, dropDownText } } = props;

  return (
    <DropDownItem onClick={open}>
      <Icon name={iconName} fixed />
      <span className="edit-button-padding">{dropDownText}</span>
      <Modal {...props} />
    </DropDownItem>
  );
};

Action.propTypes = {
  open: T.func.isRequired,
  config: T.shape({
    key: T.string.isRequired,
    dropDownText: T.string.isRequired,
    iconName: T.string.isRequired
  })
};

const satisfiesRules = (record, currentUser) => rules =>
  rules.every(rule => rule(record, currentUser));

const withRules = renderIf(
  ({ config: { rules, authorized = () => true }, inventory, currentUser }) =>
    satisfiesRules(inventory.toJS(), currentUser.toJS())(rules) &&
    authorized(currentUser.toJS(), inventory.toJS())
);

const actionWithRules = withRules(toggleSwitch("editing")(Action));

export default connect(state => ({
  currentUser: state.session.get(USER)
}))(actionWithRules);



// WEBPACK FOOTER //
// ./app/modules/inventories/components/Detail/Header/DropdownActions/Action.jsx